import { isWangxiaoBiz, isSuZhiBiz, isXuekeBiz, getDomain, isGaozhongBiz } from './business'
import { XES_SUBJECT_DOMAIN, XES_XES_DOMAIN, XES_VIPX_DOMAIN, XES_ACCOUNT_DOMAIN } from './domain'
/**
 * 获取web当前的origin
 * @returns {string} '//www.xueersi.com'
 * '//www.xiwang.com' // 新学科
 * export const XES_XES_DOMAIN = '//www.xueersi.com' // 学而思
 * export const XES_SUYANG_DOMAIN = '//www.xessuyang.com' // 素质
 * export const XES_VIPX_DOMAIN = '//www.vipx.com' // 高中 (new)
 */
export const getWebCurrentOrigin = () => {
  let host = ''
  if (isWangxiaoBiz() || isSuZhiBiz()) {
    host = XES_XES_DOMAIN
  } else if (isXuekeBiz()) { // 新学科
    host = XES_SUBJECT_DOMAIN
  } else if (isGaozhongBiz()) { // 高中
    host = XES_VIPX_DOMAIN
  }
  return getDomain({ host })
}

/**
 * 根据环境不同返回不同的url地址
 * @param {object} options 必填
 * @param {string} options.xes 必填   - 学而思、素质 默认是 www.xueersi.com
 * @param {string} options.grade 必填 - 高中
 * @param {string} options.subject  必填 - 新学科
 *
 * @param {object} settings 选填 默认 { isAccountOrigin: false }
 * @param {string} settings.isAccountOrigin 选填  默认false 。为true的时候 xueersi的origin是 account.xueersi.com
 * @returns {string} 根据环境 返回对应的url地址
 */
export const getWebCurrentLocationHref = (options, settings = { isAccountOrigin: false }) => {
  if (!options) {
    throw new Error('options必填')
  }

  ['xes', 'grade', 'subject'].forEach((key) => {
    if (!options[key]) {
      throw new Error(`options参数缺少 ${key}`)
    }
  })

  let host = ''
  let path = ''
  if (isWangxiaoBiz() || isSuZhiBiz()) {
    const { isAccountOrigin } = settings
    host = isAccountOrigin ? XES_ACCOUNT_DOMAIN : XES_XES_DOMAIN
    path = options.xes
  } else if (isXuekeBiz()) { // 新学科
    host = XES_SUBJECT_DOMAIN
    path = options.subject
  } else if (isGaozhongBiz()) { // 高中
    host = XES_VIPX_DOMAIN
    path = options.grade
  }
  const origin = getDomain({ host })
  return `${origin}${path}`
}



// WEBPACK FOOTER //
// ./node_modules/@xes/trade-toolkit/src/web.js